// import Vue from 'vue';
// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
import 'zrender/lib/svg/svg';
// 引入折线图
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
// 引入legend组件
import 'echarts/lib/component/legend';

export default echarts;

// Vue.prototype.$echarts = echarts;
